import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@/components/common/button/Button';
import Card from '@/components/common/card/Card';
import AlertMessage from '@/components/layout/message/AlertMessage';
import styles from '../../VirtualSimulationPresenter.module.css';
import type { startScreenProps } from './types.props';


const StartScreen: React.FC<startScreenProps> = ({
    simulationName,
    sessionNumber,
    durationMinutes,
    onStart,
    isSubmitting
}) => {
    const navigate = useNavigate();

    return (
        <div className={styles.centerContainer}>
            <Card className={styles.startCard}>
                <div className={styles.iconWrapper}>
                    <svg className={styles.startIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    </svg>
                </div>
                <h1>{simulationName}</h1>
                <p className={styles.subtitle}>Estás a punto de comenzar la Sesión {sessionNumber}.</p>
                <p className={styles.durationInfo}>Tendrás <strong>{durationMinutes} minutos</strong> para completar esta sesión.</p>
                <AlertMessage type="warning" title="¡Atención!">
                    Una vez que inicies, el temporizador no se detendrá, incluso si cierras la pestaña o pierdes la conexión.
                </AlertMessage>
                <div className={styles.buttonGroup}>
                    <Button variant="secondary" onClick={() => navigate('/student-home')}>Volver al panel</Button>
                    <Button variant="primary" onClick={onStart} isLoading={isSubmitting}>Iniciar sesión {sessionNumber}</Button>
                </div>
            </Card>
        </div>
    );
};

export default StartScreen;
